<template>
    <div class="sidebar">
        <div class="sidebar__brand-bg">
            <img class="sidebar__brand" src="../../../../static/media/images/Logo.svg" alt="">
            <button @click="toggleMinimizeMenu" type="button" class="sidebar__minimize"></button>
        </div>

        <div class="sidebar__actions">
            <!--
            Required params:
                icon(String),
                withText(Boolean) ? text(String)
                withAction(Boolean) ? action(Function) : linkName(String)
            -->
            <sidebar-item :withAction="true" :action="goToHomepage" :withText="true" icon="i-home" linkName="home" :text="$t('translation.backToHomepage')" />
            <sidebar-item :withAction="true" :action="downloadToRobot" :withText="true" icon="i-download" linkName="home" :text="$t('translation.downloadToRobot')" />

            <div class="sidebar__item--group">
                <!--<sidebar-item :withAction="true" :action="save.bind(this)" icon="i-save"/>-->
                <!--<sidebar-item :withAction="true" :action="folder.bind(this)" icon="i-folder"/>-->
                <a href="javascript:;" @click="save" class="sidebar__item">
                    <span class="sidebar__button button-circle button-circle--better">
                        <span class="button-circle__icon i-save"></span>
                    </span>
                </a>

                <a v-if="isDefinedOpenFile" href="javascript:;" @click="openFileNative" class="sidebar__item">
                    <span class="sidebar__button button-circle button-circle--better">
                        <span class="button-circle__icon i-folder"></span>
                    </span>
                </a>
                <label v-else class="sidebar__item">
                    <input type="file" ref="file" @change="openFile" class="sidebar__file">
                    <span class="sidebar__button button-circle button-circle--better">
                        <span class="button-circle__icon i-folder"></span>
                    </span>
                </label>

            </div>

        </div>

        <div class="sidebar__navigation menu-navigation">
            <div class="menu-navigation__panel">
                <template v-if="showScroller">
                    <span v-if="scrollBottom" @click="scroll(50, 400)" class="menu-navigation__bottom"></span>
                    <span v-else @click="scroll(50, 400)" class="menu-navigation__top"></span>
                </template>
            </div>
        </div>

    </div>
</template>

<script>
    import menuMixin from '../../../mixins/menu';
    import SidebarItem from './SidebarItem';
    import { saveAs } from 'file-saver';

    export default {
        props: {
            download: {
                required: false,
            },
        },
        mixins: [
            menuMixin,
        ],
        components: {
            SidebarItem,
        },
        data () {
            return {
                mount: false,
                scrollOffset: 0,
                scrollBottom: true,
                isDefinedOpenFile: false,
            }
        },
        computed: {
            scrollHeight() {
                if (this.mount && $('.blocklyTreeRoot')[0]) {
                    return $('.blocklyTreeRoot')[0].scrollHeight - $('.blocklyTreeRoot')[0].offsetHeight;
                }

                return 0;
            },
            showScroller() {
                if (this.mount && $('.blocklyTreeRoot')[0]) {
                    return $('.blocklyTreeRoot')[0].scrollHeight !== $('.blocklyTreeRoot')[0].offsetHeight;
                }

                return false;
            },
        },
        methods: {
            scroll(step, speed) {
                const offsetTop = $('.blocklyTreeRoot')[0].scrollTop;
                const changeOffset = this.scrollBottom ? offsetTop + step : offsetTop - step;

                $('.blocklyTreeRoot').animate({scrollTop: changeOffset}, speed);

                if (this.scrollHeight - offsetTop <= 10) {
                    this.scrollBottom = false;
                } else if (offsetTop === 0) {
                    this.scrollBottom = true;
                }
            },
            save() {
                try {
                    // jsBridge.saveFile(this.download);

                    console.log('save');
                    window.invokeCSCode('save');
                } catch (e) {
                    let blob = new Blob([this.download], {
                        type: 'text/plain;charset=utf-8',
                    });

                    saveAs(blob, "golanix.glx");
                }
            },
            openFileNative() {
                try {
                    // jsBridge.openFile();

                    console.log('open');
                    window.invokeCSCode('open');
                } catch (e) {
                    // handle
                }
            },
            folder() {
                console.log('foldered');
            },
            openFile(e) {
                let file = this.$refs.file.files[0];

                if (file) {
                    let reader = new FileReader();
                    reader.readAsText(file, 'UTF-8');

                    reader.onload = (e) => {
                        this.$emit('open-file', e.target.result);

                        this.$refs.file.value = '';
                    }
                }
            },
            goToHomepage() {
                window.Swal({
                    title: this.$t('translation.projectDoYouWantSave'),
                    type: 'warning',
                    showCloseButton: true,
                    showCancelButton: true,
                    confirmButtonText: this.$t('translation.yes'),
                    cancelButtonText: this.$t('translation.no'),
                }).then((result) => {
                    if (result.value) {
                        try {
                            // jsBridge.saveFile(this.download);
                            console.log('save');

                            window.invokeCSCode('save');
                        } catch (e) {
                            let blob = new Blob([this.download], {
                                type: 'text/plain;charset=utf-8',
                            });

                            saveAs(blob, "golanix.glx");
                        }

                        setTimeout(() => {
                            this.$emit('go-to-homepage', true);
                        }, 5000);
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                        this.$emit('go-to-homepage', true);
                    }
                });
            },
            toggleMinimizeMenu() {
                this.menuToggledSidebar = !this.menuToggledSidebar;

                this.$emit('toggle-menu', this.menuToggledSidebar);
            },
            downloadToRobot() {
                try {
                    // jsBridge.openFile();

                    console.log('download-to-robot');
                    window.invokeCSCode('download-to-robot');
                } catch (e) {
                    // handle
                }
            },
        },
        mounted() {
            this.mount = true;

            setTimeout(() => {
                $('.blocklyTreeRoot').on('scroll', () => {
                    const offsetTop = $('.blocklyTreeRoot')[0].scrollTop;

                    if (this.scrollHeight - offsetTop <= 10) {
                        this.scrollBottom = false;
                    } else if (offsetTop === 0) {
                        this.scrollBottom = true;
                    }
                });
            }, 1000);

            setInterval(() => {
                this.isDefinedOpenFile = window.isExistsInvokeCSCode();
            }, 1000);
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/Code/sidebar/SidebarMenu.vue